.filter {
	position: relative;
	margin-bottom: 10px;

	.filter_type {
		display: flex;
		justify-content: center;
		align-items: center;
		margin-bottom: 5px;

		.type_quantity {
			background: #bbbbbb;
			color: white;
			min-width: 7em;
			padding-left: 10px;
			border-top-left-radius: 10px;
			border-bottom-left-radius: 10px;
			text-align: left;
			border-right: 0.5px solid white;
			cursor: pointer;
			font-size: 13px;

			&:hover {
				background-color: #7fb02f;
			}

			&.active {
				background-color: #7fb02f;
			}
		}

		.type_price {
			background: #bbbbbb;
			color: white;
			min-width: 7em;
			padding-right: 10px;
			border-top-right-radius: 10px;
			border-bottom-right-radius: 10px;
			text-align: right;
			border-left: 0.5px solid white;
			cursor: pointer;
			font-size: 13px;

			&:hover {
				background-color: #7fb02f;
			}

			&.active {
				background-color: #7fb02f;
			}
		}
	}

	.filter_div {
		display: flex;
		justify-content: center;

		.filter_button {
			color: white;
			background-color: #7fb02f;
			border-radius: 10px;
			font-size: 13px;
			padding: 2px 7px;
			cursor: pointer;

			&:hover {
				background-color: #5a8217;
			}
		}
	}

	.filter_content {
		position: absolute;
		top: 30px;
		border-radius: 10px;
		box-shadow: 5px 5px 5px #3d482a4a;
		max-width: 25em;
		z-index: 100;

		.filter_years {
			display: flex;
			justify-content: space-between;
			margin-bottom: 6px;

			.filter_year {
				font-weight: 600;
				font-size: 20px;
			}

			.filter_icon {
				width: 1em;
				height: 1em;
				cursor: pointer;
			}
		}

		.filter_months {
			display: flex;
			flex-direction: row;
			flex-wrap: wrap;

			.filter_month {
				width: 25%;
				padding: 5px;
				cursor: pointer;

				.filter_month_name {
					font-size: 13px;
					display: flex;
					min-height: 3em;
					justify-content: center;
					align-items: center;
					border-radius: 5px;
					background-color: #f8f9fa;
					color: #7fb02f;
					border: 1px solid #7fb02f;

					&.active {
						background-color: #7fb02f;
						color: white;
					}
				}
			}
		}

		.filter_apply {
			display: flex;
			justify-content: flex-end;

			.filter_button_apply {
				margin-top: 3px;
				background-color: #7fb02f;
				color: white;
				border-radius: 5px;
				padding: 5px 40px;
				font-size: 14px;
				cursor: pointer;

				&:hover {
					background-color: #5a8217;
				}
			}
		}
	}
}

.expiration {
	height: 80%;
	padding: 0px 10px;

	.expiration_div {
		display: flex;
		justify-content: space-between;

		@media screen and (max-width: 1500px) {
			font-size: 13px;
		}

		.expiration_text {
			width: 50%;
		}

		.expiration_quantity {
			text-align: right;
			width: 25%;
			font-weight: 500;
		}

		.expiration_percentage {
			text-align: right;
			width: 25%;
		}
	}

	.expiration_bar {
		width: 100%;
		height: 1em;
		background: #e4e5ed;
		border-radius: 10px;
		margin-top: 5px;
		margin-bottom: 10px;
	}
}

.table_dashboard {
	.th {
		background-color: #81ba43;
		padding: 5px;
		font-weight: 400;
		border: none;
		color: white;
		text-align: center;
	}

	.td {
		font-size: 13px;
		padding: 5px;

		&.center {
			text-align: center;
		}
	}

	.button_confirm {
		display: flex;
		justify-content: center;
		padding: 6px;
	}
}
